<template>
  <div id="mainmenu-mobile" class="menu">
    <MenuList
      :baseApiUrl="baseApiUrl"
      :menuItems="menuItems"
      :rootPageId="rootPageId"
      :currentPageId="currentPageId"
      :currentActiveId="currentActiveId"
      :path="path"
      :level="level"
      :showLinksText="texts.showLinksText"
      @setActiveLink="setActiveLink"
    ></MenuList>
  </div>
</template>

<script>
import { computed } from "vue";
import MenuList from "./components/MenuList.vue";
import menuservice from "../plugins/menuservice";
import loadview from "../../script/loadview";

export default {
  name: "MobileMenu",
  props: {
    baseApiUrl: String,
    menuItems: Array,
    currentPageId: Number,
    currentActiveId: Number,
    path: Array,
    texts: Object,
    userOrganisationUids: {
      type: Array,
      required: false,
      default: [],
    },
    userProgramCodes: {
      type: Array,
      required: false,
      default: [],
    },
    userUmuId: {
      type: String,
      required: false,
      default: "",
    },
  },
  data: function () {
    return {
      level: 0,
      rootPageId: 0,
      activeLink: 0,
      activeParentLink: 0,
      currentExpanded: undefined,
    };
  },
  components: {
    MenuList,
  },
  provide() {
    return {
      menuservice: menuservice,
      activeLink: computed(() => this.activeLink),
      activeParentLink: computed(() => this.activeParentLink),
      currentExpanded: computed(() => this.currentExpanded),
      userOrganisationUids: computed(() => this.userOrganisationUids),
      userProgramCodes: computed(() => this.userProgramCodes),
      userUmuId: computed(() => this.userUmuId),
      navigatedText: computed(() => this.texts.navigatedText),
    };
  },
  created() {
    var self = this;
    window.onpopstate = function (event) {
      if (window.location.hash) return;
      self.loadPartialView(document.location, false);
    };
  },
  methods: {
    setActiveLink: function (id, parentId, target) {
      this.activeLink = id;
      this.activeParentLink = parentId;
      this.currentExpanded = target;
    },
    loadPartialView: function (url, push) {
      menuservice.loadPartialView(url).then((response) => {
        loadview.loadPartialViewMobile(
          response,
          push,
          url,
          this.texts.navigatedText
        );
      });
    },
  },
};
</script>
